import { render, staticRenderFns } from "./managersSheNotice.vue?vue&type=template&id=08e81844&"
import script from "./managersSheNotice.vue?vue&type=script&lang=js&"
export * from "./managersSheNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports